import React, { useState } from "react";
import { Link, Links } from "react-router-dom";

function AnimeSeriesCard({ animeSeriesData }) {
  const [naContentHover, setNaContentHover] = useState(false);
  const [hoveredIdx, setHoveredIdx] = useState(null);

  return (
    <div className="mps-cards-container">
      {animeSeriesData.map((item, idx) => {
        // Handle color background
        let gradient = "#fff";
        if (
          item.colorBackground &&
          item.colorBackground[0] &&
          Array.isArray(item.colorBackground[0].Colors)
        ) {
          const { Degrees, Colors } = item.colorBackground[0];
          gradient = `linear-gradient(${Degrees}deg, ${Colors.join(", ")})`;
        }

        // Handle imageBack as array
        const backImage =
          item.imageBack && item.imageBack[0] ? item.imageBack[0].image : "";
        const backOpacity =
          item.imageBack && item.imageBack[0] ? item.imageBack[0].opacity : 1;

        return (
          <Link
            to="/products"
            state={{ animeName: item.seriesName }}
            className="mps-card"
            key={idx}
            style={{ background: gradient }}
            onMouseEnter={() => setHoveredIdx(idx)}
            onMouseLeave={() => setHoveredIdx(null)}
            onClick={() => {
              localStorage.setItem(
                "redirectAfterLogin",
                JSON.stringify({
                  path: window.location.pathname,
                  scrollTop: 0,
                })
              );
            }}
          >
            {" "}
            <img
              className="mps-card-img-logo"
              src={`${window.location.origin}/Assets/AnimeS/${item.imageLogo}`}
              alt={backImage}
            />
            <img
              className={`mps-card-img-back ${
                hoveredIdx === idx ? "show-back" : ""
              }`}
              src={`${window.location.origin}/Assets/AnimeS/${backImage}`}
              alt={backImage}
            />
            <img
              className="mps-card-img-front"
              src={`${window.location.origin}/Assets/AnimeS/${item.imageFront}`}
              alt={item.imageFront}
            />
          </Link>
        );
      })}
    </div>
  );
}

export default AnimeSeriesCard;
